export const ZOOM_OPTIONS = {
  container: '.pswp',
  options: {
    maxSpreadZoom: 1,
    allowPanToNext: false,
    clickToCloseNonZoomable: false,
    history: false
  }
}

export const TRACKING_EVENTS = {
  zoomClick: {
    eventCategory: 'PagProduto',
    eventAction: 'clicou_super_zoom',
    eventLabel: 'fotos_produtos'
  },
  sketchfabClick: {
    eventCategory: 'PagProduto',
    eventAction: 'clicou'
  },
  prevArrowClick: {
    eventCategory: 'Pag_produto',
    eventAction: 'clicou_prev',
    eventLabel: 'galeria-de-foto'
  },
  nextArrowClick: {
    eventCategory: 'Pag_produto',
    eventAction: 'clicou_next',
    eventLabel: 'galeria-de-foto'
  }
}
